export const membershipKeys = {
  all: ['membership'] as const,

  user: (userId: string | undefined) => [...membershipKeys.all, 'user', userId] as const,

  policyOverviews: () => ['policy-overview'] as const,
  policyOverview: (userId: string | undefined) => [...membershipKeys.policyOverviews(), userId] as const,

  policies: () => [...membershipKeys.all, 'policies'] as const,
  approvedPolicy: (userId: string | undefined) => [...membershipKeys.policies(), 'approved', userId] as const,
  pendingPolicies: (userId: string | undefined) => [...membershipKeys.policies(), 'pending', userId] as const,
  latestUpload: (userId: string | undefined) => [...membershipKeys.policies(), 'latest-upload', userId] as const,
  latestReview: (uploadData: unknown) => [...membershipKeys.policies(), 'latest-review', uploadData] as const,

  stats: () => [...membershipKeys.all, 'stats'] as const,
} as const
